import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const AddAShopSignUp = (props) => {

    const handleCallback = () => {
        const { feedbackCallback } = props;

        if (feedbackCallback && {}.toString.call(feedbackCallback) === '[object Function]') {
            return feedbackCallback();
        }
    }

    return (
        <div className='addashop-container'>
            <div className='addashop-logo'>
                <img src='/content/OtherStock/images/AddAShop/AddAShop.png' alt='AddAShop Logo' />
            </div>
            <div className='addashop-text'>
                <TranslationText tKey='sandhills.tradesites.mvc.dontreinventyoursite' />
            </div>
            <div className='addashop-buttons'>
                <a id='addashop-signup' href={props.signUpUrl} className='button ts-button addashop-signup-button' target='_blank' aria-label={translator.translate('sandhills.startsellingnow') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}><TranslationText tKey='sandhills.startsellingnow' /></a>
                <a id='have-questions' role='button' tabIndex='0' className='button ts-button addashop-questions-button' onClick={handleCallback} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); handleCallback();}}}><TranslationText tKey='sandhills.havequestions' /></a>
            </div>
        </div>
    );
};

export default AddAShopSignUp;